import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DesktopAccessDisabledIcon(props: IconProps) {
    return <Icon {...props} iconKey={"desktop_access_disabled"}/>
}
